export const courseDetailsSelector = state => state.courseDetails;
